class Search {
  constructor(element) {
    this.element = element;
    this.init();
  }
  init() {
    this.input = this.element.querySelector('input');
    this.button = this.element.querySelector('button');
    if (this.input) {
      // 监听input事件并添加防抖
      this.input.addEventListener('input', this.debounce(this.handleChange.bind(this), 300));
      // 监听focus
      this.input.addEventListener('focus', this.handleFocus.bind(this));
    }
    if (this.button) {
      this.button.addEventListener('click', this.clickSearch.bind(this));
    }
    this.element.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
    });
    this.element.querySelector('#clear-btn').addEventListener('click', () => {
      this.element.querySelector('input').value = '';
      this.element.querySelector('input').setAttribute('data-has-value', 'false');
      this.element.dispatchEvent(new CustomEvent('search', { detail: '' }));
    });
  }
  handleFocus(event) {
    // 触发事件
    this.element.dispatchEvent(new CustomEvent('focus', { detail: event.target.value }));
  }
  handleChange(event) {
    if (event.target.value.trim() !== '') {
      this.element.querySelector('input').setAttribute('data-has-value', 'true');
    } else {
      this.element.querySelector('input').setAttribute('data-has-value', 'false');
    }
    // 触发事件
    this.element.dispatchEvent(new CustomEvent('search', { detail: event.target.value }));
  }
  debounce(fn, delay) {
    let timer = null;
    return function () {
      clearTimeout(timer);
      timer = setTimeout(() => fn.apply(this, arguments), delay);
    };
  }
  clickSearch() {
    if (this.element.querySelector('input').value.trim() === '') {
      this.element.querySelector('input').focus();
      window.litime.showToast('warning', window.i18n.please_input_search_keyword);
      return;
    }
    this.element.dispatchEvent(new CustomEvent('clickSearch', { detail: this.element.querySelector('input').value }));
  }
}
$(function () {
  // 在这里编写需要在文档加载完成后执行的代码
  if (!customElements.get('sale-support-search-result')) {
    customElements.define(
      'sale-support-search-result',
      class SaleSupportSearchResult extends HTMLElement {
        keyword = '';
        mobileKeyword = '';
        firstLoad = true;
        currentType = 'all';
        constructor() {
          super();
        }

        connectedCallback() {
          //   this.init();
          this.initMobile();
        }

        async fetchSearchAllData(keyword) {
          try {
            const res = await window.litime.http.get(
              `/shopify/support-center/page/all`,
              {
                data: {
                  query: keyword,
                },
              },
              'business-api'
            );
            if (res.code === 200) {
              return res.data;
            } else {
              throw new Error(res.message);
            }
          } catch (error) {
            console.error(error, error);
          }
        }
        async fetchSearchProductsData(keyword) {
          try {
            const res = await window.litime.http.get(
              `/shopify/support-center/page/products`,
              {
                data: { query: keyword, pageSize: 9999 },
              },
              'business-api'
            );
            if (res.code === 200) {
              return res.data;
            } else {
              throw new Error(res.message);
            }
          } catch (error) {
            console.error(error, error);
          }
        }
        async fetchSearchBlogsData(keyword) {
          try {
            const res = await window.litime.http.get(
              `/shopify/support-center/page/blogs`,
              {
                data: { query: keyword, pageSize: 9999 },
              },
              'business-api'
            );
            if (res.code === 200) {
              return res.data;
            } else {
              throw new Error(res.message);
            }
          } catch (error) {
            console.error(error, error);
          }
        }
        async fetchSearchManualsData(keyword) {
          try {
            const res = await window.litime.http.get(
              `/shopify/support-center/page/manuals`,
              {
                data: { query: keyword, pageSize: 9999 },
              },
              'business-api'
            );
            if (res.code === 200) {
              return res.data;
            } else {
              throw new Error(res.message);
            }
          } catch (error) {
            console.error(error, error);
          }
        }

        async searchEvent(keyword, contain, type = 'all') {
          const url = new URL(window.location.href);
          url.searchParams.set('type', type);
          window.history.replaceState({}, '', url.toString());
          contain.classList.remove('hidden');
          this.showLoading(contain);
          let data = {};
          if (type === 'all') {
            data = await this.fetchSearchAllData(keyword);
          } else if (type === 'products') {
            data.products = await this.fetchSearchProductsData(keyword);
          } else if (type === 'blogs') {
            data.blogs = await this.fetchSearchBlogsData(keyword);
          } else {
            data.manuals = await this.fetchSearchManualsData(keyword);
          }
          const wrapper = contain.querySelector('.result-list-container__wrapper');
          wrapper.innerHTML = '';
          if (data?.products?.records?.length > 0) {
            const productList = this.renderProductList(data.products, contain);
            wrapper.innerHTML += productList;
          }
          if (data?.blogs?.records?.length > 0) {
            const blogList = this.renderBlogList(data.blogs, contain);
            wrapper.innerHTML += blogList;
          }
          if (data?.manuals?.records?.length > 0) {
            const manualList = this.renderMunualList(data.manuals, contain);
            wrapper.innerHTML += manualList;
          }
          const resultTypeContainer = this.querySelector('.result-type-container');
          if (this.currentType === 'all') {
            const blog = this.querySelector('[data-type="blogs"]');
            const product = this.querySelector('[data-type="products"]');
            const manual = this.querySelector('[data-type="manuals"]');

            if (data?.products?.records?.length === 0) {
              product.classList.add('hidden');
            } else {
              product.classList.remove('hidden');
            }
            if (data?.blogs?.records?.length === 0) {
              blog.classList.add('hidden');
            } else {
              blog.classList.remove('hidden');
            }
            if (data?.manuals?.records?.length === 0) {
              manual.classList.add('hidden');
            } else {
              manual.classList.remove('hidden');
            }
          }
          if (
            data?.products?.records?.length === 0 &&
            data?.blogs?.records?.length === 0 &&
            data?.manuals?.records?.length === 0
          ) {
            // resultEmpty.classList.remove('hidden');
            contain.setAttribute('data-empty', 'true');
            const resultEmptyDesc = contain.querySelector('.result-empty-desc');
            if (resultEmptyDesc.querySelector('.keyword')) {
              resultEmptyDesc.querySelector('.keyword').innerText = this.mobileKeyword;
            }
            const html = resultEmptyDesc.innerHTML;
            resultEmptyDesc.innerHTML = html.replace(
              '####',
              `<span class="keyword" style="color: var(--theme-color)">${this.mobileKeyword}</span>`
            );
            resultTypeContainer.classList.add('hidden');
            this.hideLoading(contain, true);
          } else {
            // resultEmpty.classList.add('hidden');
            this.hideLoading(contain);
            contain.setAttribute('data-empty', 'false');
            resultTypeContainer.classList.remove('hidden');
          }
          const resultWrapper = this.querySelector('.result-wrapper');
          // 浏览器滚动到resultWrapper顶部距离
          const resultWrapperTop = resultWrapper.offsetTop;
          window.scrollTo({
            top: resultWrapperTop,
            behavior: 'smooth',
          });
        }

        initMobile() {
          const inputWrapper = this.querySelector(
            '.sale-support-banner__mobile__search .sale-support-search__container'
          );
          const search = new Search(inputWrapper);
          const contain = this.querySelector('.result-list-container__mobile');
          // 获取地址栏参数keyword
          const keyword = new URLSearchParams(window.location.search).get('keyword');
          const type = new URLSearchParams(window.location.search).get('type');
          const resultTypeItems = this.querySelectorAll('.result-type-item');

          if (keyword) {
            this.querySelector('.result-type-container__wrapper').classList.add('hidden');
            this.querySelector('.result-type-container__wrapper').classList.remove('flex');
            this.querySelector('.result-list-container__mobile').classList.remove('border-l');
            inputWrapper.querySelector('input').value = keyword;
            inputWrapper.querySelector('input').dispatchEvent(new Event('input', { detail: keyword }));
            this.mobileKeyword = keyword;
            this.currentType = 'all';
            if (type) {
              this.currentType = type;
              resultTypeItems.forEach((item) => {
                item.setAttribute('data-active', 'false');
              });
              const activeItem = this.querySelector(`[data-type="${type}"]`);
              if (window.innerWidth <= 576) {
                const resultTypeContainer = this.querySelector('.result-type-container');
                const itemOffset = activeItem.offsetLeft;
                const listWidth = resultTypeContainer.offsetWidth;
                const itemWidth = activeItem.offsetWidth;
                const centerOffset = (listWidth - itemWidth) / 2;
                resultTypeContainer.scrollTo({
                  left: itemOffset - centerOffset,
                  behavior: 'smooth',
                });
              }
              activeItem.setAttribute('data-active', 'true');
            }
            this.searchEvent(keyword, contain, type ? type : 'all');
          }
          search.element.addEventListener('clickSearch', (event) => {
            this.mobileKeyword = event.detail;
            this.currentType = 'all';
            // 修改地址栏keyword，不刷新页面
            const url = new URL(window.location.href);
            url.searchParams.set('keyword', event.detail);
            window.history.replaceState({}, '', url.toString());
            this.querySelector('.result-type-container__wrapper').classList.add('hidden');
            this.querySelector('.result-type-container__wrapper').classList.remove('flex');
            this.querySelector('.result-list-container__mobile').classList.remove('border-l');

            const resultTypeContainer = this.querySelector('.result-type-container');
            const resultTypeItem = resultTypeContainer.querySelector(`[data-type="all"]`);
            if (window.innerWidth <= 576) {
              const itemOffset = resultTypeItem.offsetLeft;
              const listWidth = resultTypeContainer.offsetWidth;
              const itemWidth = resultTypeItem.offsetWidth;
              const centerOffset = (listWidth - itemWidth) / 2;
              resultTypeContainer.scrollTo({
                left: itemOffset - centerOffset,
                behavior: 'smooth',
              });
            }
            const resultTypeItems = this.querySelectorAll('.result-type-item');
            resultTypeItems.forEach((item) => {
              item.setAttribute('data-active', 'false');
            });
            resultTypeItem.setAttribute('data-active', 'true');
            this.searchEvent(event.detail, contain, 'all');
          });

          resultTypeItems.forEach((item) => {
            item.addEventListener('click', () => {
              if (window.innerWidth <= 576) {
                const resultTypeContainer = this.querySelector('.result-type-container');
                const itemOffset = item.offsetLeft;
                const listWidth = resultTypeContainer.offsetWidth;
                const itemWidth = item.offsetWidth;
                const centerOffset = (listWidth - itemWidth) / 2;
                resultTypeContainer.scrollTo({
                  left: itemOffset - centerOffset,
                });
              }
              resultTypeItems.forEach((item) => {
                item.setAttribute('data-active', 'false');
              });
              item.setAttribute('data-active', 'true');
              this.currentType = item.getAttribute('data-type');
              this.searchEvent(this.mobileKeyword, contain, this.currentType);
            });
          });
          // 事件委托
          contain.addEventListener('click', (e) => {
            if (e.target.closest('.result-list-item__more')) {
              e.preventDefault();
              e.stopPropagation();
              const type = e.target.closest('.result-list-item__more').getAttribute('data-type');
              const resultTypeItems = this.querySelectorAll('.result-type-item');
              resultTypeItems.forEach((item) => {
                item.setAttribute('data-active', 'false');
              });
              const resultTypeItem = this.querySelector(`.result-type-item[data-type="${type}"]`);
              resultTypeItem.setAttribute('data-active', 'true');
              this.currentType = type;
              if (window.innerWidth <= 576) {
                const resultTypeContainer = this.querySelector('.result-type-container');
                const itemOffset = resultTypeItem.offsetLeft;
                const listWidth = resultTypeContainer.offsetWidth;
                const itemWidth = resultTypeItem.offsetWidth;
                const centerOffset = (listWidth - itemWidth) / 2;
                resultTypeContainer.scrollTo({
                  left: itemOffset - centerOffset,
                  behavior: 'smooth',
                });
              }
              this.searchEvent(this.mobileKeyword, contain, this.currentType);
            }
            if (e.target.closest('.result-list-item__content-item-download')) {
              const downloadUrl = e.target
                .closest('.result-list-item__content-item-download')
                .getAttribute('data-download-url');
              if (downloadUrl) {
                // 检测是否为 iOS Safari
                const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

                if (isIOS) {
                  // iOS Safari 使用简单的下载方式
                  const link = document.createElement('a');
                  link.href = downloadUrl;
                  link.download = this.getCleanFilename(downloadUrl);
                  link.target = '_blank';
                  link.click();
                } else {
                  // 其他浏览器使用 fetch 强制下载
                  fetch(downloadUrl)
                    .then((response) => response.blob())
                    .then((blob) => {
                      // 创建临时 URL
                      const blobUrl = window.URL.createObjectURL(blob);

                      // 创建下载链接
                      const link = document.createElement('a');
                      link.href = blobUrl;

                      // 提取干净的文件名
                      link.download = this.getCleanFilename(downloadUrl);

                      // 触发下载
                      document.body.appendChild(link);
                      link.click();
                      document.body.removeChild(link);

                      // 清理临时 URL
                      window.URL.revokeObjectURL(blobUrl);
                    })
                    .catch((error) => {
                      console.error('下载失败:', error);
                      // 回退到简单的 a 标签下载
                      const link = document.createElement('a');
                      link.href = downloadUrl;
                      link.download = this.getCleanFilename(downloadUrl);
                      link.target = '_blank';
                      link.click();
                    });
                }
              }
            }
            if (e.target.closest('.result-list-item__content-item-title')) {
              if (this.currentType === 'all') {
                const handle = e.target.closest('.result-list-item__content-item-title').getAttribute('data-handle');
                window.location.href = `/products/${handle}#manual`;
              } else {
                const downloadUrl = e.target
                  .closest('.result-list-item__content-item-title')
                  .getAttribute('data-download-url');
                if (downloadUrl) {
                  window.open(downloadUrl, '_blank');
                }
              }
            }
            const item = e.target.closest('.result-list-item__content-item');
            if (item && item.getAttribute('data-type') === 'blogs') {
              const handle = item.getAttribute('data-handle');
              window.location.href = `${handle}`;
              // 修改地址栏type参数
              const url = new URL(window.location.href);
              url.searchParams.set('type', 'blogs');
              window.history.replaceState({}, '', url.toString());
            }
            if (item && item.getAttribute('data-type') === 'products') {
              const handle = item.getAttribute('data-handle');
              window.location.href = `/products/${handle}`;
              // 修改地址栏type参数
              const url = new URL(window.location.href);
              url.searchParams.set('type', 'products');
              window.history.replaceState({}, '', url.toString());
            }
            if (e.target.closest('.result-empty-desc .highlight')) {
              window.litime.openChatApp();
            }
          });
        }

        closeSearchPopup() {
          const contain = this.querySelector('.result-list-container');
          contain.classList.add('hidden');
          const mobileContain = this.querySelector('.result-list-container__mobile');
          mobileContain.classList.add('hidden');
        }

        showLoading(contain) {
          const loading = $(contain.querySelector('.loading-container'));
          $(contain).find('.result-list-container__wrapper').addClass('hidden');
          contain.setAttribute('data-empty', 'false');
          loading.removeClass('hidden').addClass('flex');
          // this.querySelector('.result-type-container').classList.add('opacity-0');
        }

        hideLoading(contain, isEmpty = false) {
          const loading = $(contain.querySelector('.loading-container'));
          $(contain).find('.result-list-container__wrapper').removeClass('hidden');
          $(contain).find('.result-empty').removeClass('hidden');
          loading.addClass('hidden').removeClass('flex');
          if (!isEmpty) {
            // this.querySelector('.result-type-container').classList.remove('opacity-0');
            this.querySelector('.result-type-container__wrapper').classList.remove('hidden');
            this.querySelector('.result-type-container__wrapper').classList.add('flex');
            this.querySelector('.result-list-container__mobile').classList.add('border-l');
          }
        }
        // 添加高亮方法
        highlightText(text, keyword) {
          if (!keyword || keyword.trim() === '') {
            return text;
          }

          const regex = new RegExp(this.escapeRegExp(keyword), 'gi');
          return text.replace(regex, `<span class="active">$&</span>`);
        }

        // 正则匹配
        escapeRegExp(string) {
          return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        }

        // 渲染产品列表
        renderProductList(data, element) {
          const title = element.getAttribute('data-product-name');
          const resultList = `<div class="result-list-item">
            <div class="result-list-item__title">${title}(${data.total})</div>
            <div class="result-list-item__content">
            ${data.records
              .map((item) => {
                return `<div data-type="products" class="result-list-item__content-item" data-handle="${item.handle}">
                ${this.highlightText(item.title, this.mobileKeyword.trim())}</div>`;
              })
              .join('')}
            </div>
            ${
              data.total > 5 && this.currentType === 'all'
                ? `<div data-type="products" class="result-list-item__more">
                    <span class="">
                      ${window.i18n.view_more}
                    </span>
                    <i class="*:size-[12px] *:fill-primary">
                        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" fill="none" version="1.1" width="5.200000047683716" height="9.200000047683716" viewBox="0 0 5.200000047683716 9.200000047683716"><g><path d="M1.024360023841858,0.17583202384185792L5.024260023841858,4.175740023841858L5.024260023841858,5.024260023841858L1.024673023841858,9.023860023841857L1.0242640238418579,9.024260023841858Q0.9398730238418579,9.108660023841859,0.8296100238418579,9.154330023841858Q0.7193470238418579,9.200000023841858,0.6000000238418579,9.200000023841858Q0.5409052238418579,9.200000023841858,0.4829460238418579,9.188470023841857Q0.4249860238418579,9.176940023841858,0.37039002384185793,9.154330023841858Q0.3157930238418579,9.131710023841858,0.2666580238418579,9.098880023841858Q0.21752202384185793,9.066050023841857,0.17573602384185794,9.024260023841858Q0.1339500238418579,8.982480023841857,0.10111802384185792,8.933340023841858Q0.06828702384185792,8.884210023841858,0.04567202384185787,8.829610023841857Q0.023058023841857955,8.775010023841858,0.011529023841857944,8.717050023841859Q2.384185793236071e-8,8.659090023841857,2.384185793236071e-8,8.600000023841858Q2.384185793236071e-8,8.480650023841857,0.04567202384185787,8.370390023841857Q0.09134502384185794,8.260130023841857,0.17573602384185794,8.175740023841858L0.1758910238418579,8.175580023841858L3.751470023841858,4.600000023841858L0.17583202384185792,1.024360023841858L0.17573602384185794,1.0242640238418579Q0.09134502384185794,0.9398730238418579,0.04567202384185787,0.8296100238418579Q2.384185793236071e-8,0.7193470238418579,2.384185793236071e-8,0.6000000238418579Q2.384185793236071e-8,0.5409052238418579,0.011529023841857944,0.4829460238418579Q0.023058023841857955,0.4249860238418579,0.04567202384185787,0.37039002384185793Q0.06828702384185792,0.3157930238418579,0.10111802384185792,0.2666580238418579Q0.1339500238418579,0.21752202384185793,0.17573602384185794,0.17573602384185794Q0.21752202384185793,0.1339500238418579,0.2666580238418579,0.10111802384185792Q0.3157930238418579,0.06828702384185792,0.37039002384185793,0.04567202384185787Q0.4249860238418579,0.023058023841857955,0.4829460238418579,0.011529023841857944Q0.5409052238418579,2.384185793236071e-8,0.6000000238418579,2.384185793236071e-8Q0.7193470238418579,2.384185793236071e-8,0.8296100238418579,0.04567202384185787Q0.9398730238418579,0.09134502384185794,1.0242640238418579,0.17573602384185794L1.024360023841858,0.17583202384185792Z" fill-rule="evenodd" fill="" fill-opacity="1"/></g></svg>
                    </i>
                </div>`
                : ''
            }
          </div>`;

          return resultList;
        }
        // 渲染博客列表
        renderBlogList(data, element) {
          const title = element.getAttribute('data-blog-name');
          const resultList = `<div class="result-list-item">
            <div class="result-list-item__title">${title}(${data.total})</div>
            <div class="result-list-item__content">
            ${data.records
              .map((item) => {
                return `<div data-type="blogs" class="result-list-item__content-item" data-handle="${item.handle}">
            ${this.highlightText(item.title, this.mobileKeyword.trim())}</div>`;
              })
              .join('')}
            </div>
            ${
              data.total > 5 && this.currentType === 'all'
                ? `<div data-type="blogs" class="result-list-item__more">
                    <span class="">
                        ${window.i18n.view_more}
                    </span>
                    <i class="*:size-[12px] *:fill-primary">
                        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" fill="none" version="1.1" width="5.200000047683716" height="9.200000047683716" viewBox="0 0 5.200000047683716 9.200000047683716"><g><path d="M1.024360023841858,0.17583202384185792L5.024260023841858,4.175740023841858L5.024260023841858,5.024260023841858L1.024673023841858,9.023860023841857L1.0242640238418579,9.024260023841858Q0.9398730238418579,9.108660023841859,0.8296100238418579,9.154330023841858Q0.7193470238418579,9.200000023841858,0.6000000238418579,9.200000023841858Q0.5409052238418579,9.200000023841858,0.4829460238418579,9.188470023841857Q0.4249860238418579,9.176940023841858,0.37039002384185793,9.154330023841858Q0.3157930238418579,9.131710023841858,0.2666580238418579,9.098880023841858Q0.21752202384185793,9.066050023841857,0.17573602384185794,9.024260023841858Q0.1339500238418579,8.982480023841857,0.10111802384185792,8.933340023841858Q0.06828702384185792,8.884210023841858,0.04567202384185787,8.829610023841857Q0.023058023841857955,8.775010023841858,0.011529023841857944,8.717050023841859Q2.384185793236071e-8,8.659090023841857,2.384185793236071e-8,8.600000023841858Q2.384185793236071e-8,8.480650023841857,0.04567202384185787,8.370390023841857Q0.09134502384185794,8.260130023841857,0.17573602384185794,8.175740023841858L0.1758910238418579,8.175580023841858L3.751470023841858,4.600000023841858L0.17583202384185792,1.024360023841858L0.17573602384185794,1.0242640238418579Q0.09134502384185794,0.9398730238418579,0.04567202384185787,0.8296100238418579Q2.384185793236071e-8,0.7193470238418579,2.384185793236071e-8,0.6000000238418579Q2.384185793236071e-8,0.5409052238418579,0.011529023841857944,0.4829460238418579Q0.023058023841857955,0.4249860238418579,0.04567202384185787,0.37039002384185793Q0.06828702384185792,0.3157930238418579,0.10111802384185792,0.2666580238418579Q0.1339500238418579,0.21752202384185793,0.17573602384185794,0.17573602384185794Q0.21752202384185793,0.1339500238418579,0.2666580238418579,0.10111802384185792Q0.3157930238418579,0.06828702384185792,0.37039002384185793,0.04567202384185787Q0.4249860238418579,0.023058023841857955,0.4829460238418579,0.011529023841857944Q0.5409052238418579,2.384185793236071e-8,0.6000000238418579,2.384185793236071e-8Q0.7193470238418579,2.384185793236071e-8,0.8296100238418579,0.04567202384185787Q0.9398730238418579,0.09134502384185794,1.0242640238418579,0.17573602384185794L1.024360023841858,0.17583202384185792Z" fill-rule="evenodd" fill="" fill-opacity="1"/></g></svg>
                    </i>
                </div>`
                : ''
            }
          </div>`;
          return resultList;
        }
        // 渲染说明书列表
        renderMunualList(data, element) {
          const title = element.getAttribute('data-manual-name');
          const resultList = `<div class="result-list-item">
            <div class="result-list-item__title">${title}(${data.total})</div>
            <div class="result-list-item__content">
            ${data.records
              .map((item) => {
                return `<div data-type="manuals" class="result-list-item__content-item flex items-center" >
                <div data-download-url="${item.downloadUrl}" data-handle="${
                  item.handle
                }" class="result-list-item__content-item-title">${this.highlightText(
                  item.title,
                  this.mobileKeyword.trim()
                )}</div>
                <div data-download-url="${item.downloadUrl}" class="result-list-item__content-item-download">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" class="design-iconfont">
                        <defs>
                            <clipPath id="cbird7oio__glfvbhn5oa">
                            <rect x="3" y="3" width="18" height="18" rx="0"/>
                            </clipPath>
                        </defs>
                        <rect x=".5" y=".5" width="23" height="23" rx="1.5" stroke="#EA5504"/>
                        <g clip-path="url(#cbird7oio__glfvbhn5oa)">
                            <path d="M12.00003662109375,14.7000732421875L8.40003662109375,11.1000732421875L9.35628662109375,10.1438232421875L11.32503662109375,12.1125732421875L11.32503662109375,5.7000732421875L12.67503662109375,5.7000732421875L12.67503662109375,12.1125732421875L14.64378662109375,10.1438232421875L15.60003662109375,11.1000732421875L12.00003662109375,14.7000732421875ZM7.9447866210937494,17.4000732421875Q7.38753662109375,17.4000732421875,6.99378662109375,17.0034732421875Q6.60003662109375,16.6069732421875,6.60003662109375,16.0500732421875L6.60003662109375,14.7000732421875L7.95003662109375,14.7000732421875L7.95003662109375,16.0500732421875L16.05003662109375,16.0500732421875L16.05003662109375,14.7000732421875L17.40003662109375,14.7000732421875L17.40003662109375,16.0500732421875Q17.40003662109375,16.6069732421875,17.00333662109375,17.0034732421875Q16.606536621093753,17.4000732421875,16.04928662109375,17.4000732421875L7.9447866210937494,17.4000732421875Z" fill="#EA5504"/>
                        </g>
                    </svg>
                </div>
                </div>`;
              })
              .join('')}
            </div>
            ${
              data.total > 5 && this.currentType === 'all'
                ? `<div data-type="manuals" class="result-list-item__more">
                    <span class="">
                       ${window.i18n.view_more}
                    </span>
                    <i class="*:size-[12px] *:fill-primary">
                        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" fill="none" version="1.1" width="5.200000047683716" height="9.200000047683716" viewBox="0 0 5.200000047683716 9.200000047683716"><g><path d="M1.024360023841858,0.17583202384185792L5.024260023841858,4.175740023841858L5.024260023841858,5.024260023841858L1.024673023841858,9.023860023841857L1.0242640238418579,9.024260023841858Q0.9398730238418579,9.108660023841859,0.8296100238418579,9.154330023841858Q0.7193470238418579,9.200000023841858,0.6000000238418579,9.200000023841858Q0.5409052238418579,9.200000023841858,0.4829460238418579,9.188470023841857Q0.4249860238418579,9.176940023841858,0.37039002384185793,9.154330023841858Q0.3157930238418579,9.131710023841858,0.2666580238418579,9.098880023841858Q0.21752202384185793,9.066050023841857,0.17573602384185794,9.024260023841858Q0.1339500238418579,8.982480023841857,0.10111802384185792,8.933340023841858Q0.06828702384185792,8.884210023841858,0.04567202384185787,8.829610023841857Q0.023058023841857955,8.775010023841858,0.011529023841857944,8.717050023841859Q2.384185793236071e-8,8.659090023841857,2.384185793236071e-8,8.600000023841858Q2.384185793236071e-8,8.480650023841857,0.04567202384185787,8.370390023841857Q0.09134502384185794,8.260130023841857,0.17573602384185794,8.175740023841858L0.1758910238418579,8.175580023841858L3.751470023841858,4.600000023841858L0.17583202384185792,1.024360023841858L0.17573602384185794,1.0242640238418579Q0.09134502384185794,0.9398730238418579,0.04567202384185787,0.8296100238418579Q2.384185793236071e-8,0.7193470238418579,2.384185793236071e-8,0.6000000238418579Q2.384185793236071e-8,0.5409052238418579,0.011529023841857944,0.4829460238418579Q0.023058023841857955,0.4249860238418579,0.04567202384185787,0.37039002384185793Q0.06828702384185792,0.3157930238418579,0.10111802384185792,0.2666580238418579Q0.1339500238418579,0.21752202384185793,0.17573602384185794,0.17573602384185794Q0.21752202384185793,0.1339500238418579,0.2666580238418579,0.10111802384185792Q0.3157930238418579,0.06828702384185792,0.37039002384185793,0.04567202384185787Q0.4249860238418579,0.023058023841857955,0.4829460238418579,0.011529023841857944Q0.5409052238418579,2.384185793236071e-8,0.6000000238418579,2.384185793236071e-8Q0.7193470238418579,2.384185793236071e-8,0.8296100238418579,0.04567202384185787Q0.9398730238418579,0.09134502384185794,1.0242640238418579,0.17573602384185794L1.024360023841858,0.17583202384185792Z" fill-rule="evenodd" fill="" fill-opacity="1"/></g></svg>
                    </i>
                </div>`
                : ''
            }
          </div>`;
          return resultList;
        }
        getCleanFilename(url) {
          return (url.split('/').pop() || 'download').replace(/\?.*$/, '');
        }
      }
    );
  }
});
